import moment from 'moment';
import { isEmpty } from './swap';
/**
 * 判断一个值是否为空
 * @param {*} value
 */
export const isNull = (value) => value === undefined || value === null || value === '';
/**
 * 删除空字字段，格式化前后空格
 * @param {*} value
 */
export const clearNull = (values) => {
  Object.entries(values).forEach(([key, val]) => {
    // 删除空字段
    if (isNull(val)) delete values[key];
    // 去除前后空格
    if (typeof val === 'string' && val.length) {
      values[key] = val.trim();
    }
  });
  return values;
};

/**
 * 删除空字字段，格式化前后空格，删除-1
 * @param {*} value
 */
export const clearNullJavaParam = (values) => {
  Object.entries(values).forEach(([key, val]) => {
    // 去除前后空格
    if (typeof val === 'string' && val.length) {
      values[key] = val.trim();
    }
    // 删除空字段, -1
    if (isNull(val) || String(val) === '-1') delete values[key];
  });
  return values;
};

/**
 * 格式化价格
 * @param {number} price 以分为单位的价格
 * @param {string|boolean} unit 是否带单位 默认 true 例子：formatPrice(1002) 返回 ¥10.02
 * @return {string} 以元为单位的价格
 */
export const formatPrice = (price, unit = true) => {
  if (isNull(price)) return '--';
  if (typeof unit === 'string') {
    return (price / 100).toFixed(2) + unit;
  }
  if (typeof unit === 'boolean' && unit) {
    return `¥${(price / 100).toFixed(2)}`;
  }
  return (price / 100).toFixed(2);
};

/**
 * 毫秒时间戳 转 秒时间戳
 * @param {number} time 毫秒时间戳
 * @return {string} 秒时间戳
 */
export const formatTime = (time) => {
  // eslint-disable-next-line no-underscore-dangle
  if (typeof time === 'object' && time._isAMomentObject) {
    return time.unix();
  }
  return ~~(Number(time) / 1000);
};

/**
 * 数据格式化
 * @param {string} values 待格式化的表单值
 * @param {object} options 格式化配置数组
 *        如：[
 *            {from: 'field1', to: 'field2'},
 *            {from: 'time', to: ['start_time','end_time'], type: 'time'},
 *            {from: 'location', to:['province','city','county'], type: 'number'},
 *           ]
 *        注：
 *        默认不转换类型
 *        如传time，类型需为moment，转换为秒级时间戳
 *        如传number，转换为数值型
 * @return {object}
 *     返回值：{
 *            field2: 'xxx',
 *            start_time: 1556520195,
 *            end_time: 1556520195,
 *            province: 10000,
 *            city: 101000,
 *            county: 101010,
 *           }
 */
export const formatForm = (values, options) => {
  if (values && options && options.length) {
    try {
      options.forEach((v) => {
        if (v.from && v.to) {
          if (!values[v.from]) {
            return;
          }
          if (!['time', 'number', undefined].includes(v.type)) {
            console.error('type仅支持：', 'time或number');
            return;
          }
          if (v.to instanceof Array && v.to.length) {
            if (v.type === 'time') {
              v.to.forEach((key, i) => {
                values[key] = values[v.from][i]
                  ? values[v.from][i][i === 0 ? 'startOf' : 'endOf']('d').unix()
                  : null;
              });
            } else if (v.type === 'number') {
              v.to.forEach((key, i) => {
                values[key] = values[v.from][i] ? Number(values[v.from][i]) : null;
              });
            } else {
              v.to.forEach((key, i) => {
                values[key] = values[v.from][i] ? values[v.from][i] : null;
              });
            }
            delete values[v.from];
          } else if (typeof v.to === 'string') {
            if (v.type === 'time') {
              values[v.to] = values[v.from].unix();
            } else if (v.type === 'number') {
              values[v.to] = Number(values[v.from]);
            } else if (v.type === 'string') {
              values[v.to] = isNull(v.from) ? v.from : `${values[v.from]}`;
            } else {
              values[v.to] = values[v.from];
            }
            if (v.to !== v.from) {
              delete values[v.from];
            }
          } else {
            console.error('参数错误:', v);
          }
        } else {
          console.error(
            '参数未找到，正确options示例:',
            `
          [
          {from: 'field1', to: 'field2'},
          {from: 'time', to: ['start_time','end_time'], type: 'time'},
          {from: 'location', to:['province','city','county'], type: 'number'},
          ]
          注：
          默认不转换类型
          如传time，类型需为moment，转换为秒级时间戳
          如传number，转换为数值型
          `,
          );
        }
      });
    } catch (e) {
      console.error(e);
      // throw new Error(e.toString());
    }
  }
  console.log('format', values);
  return values;
};

/**
 * 反向格式化
 * @param {*} seconds
 * @returns
 */
export const parseFormatForm = (values, options) => {
  const result = { ...values };
  if (values && !!options?.length) {
    try {
      options.forEach((v) => {
        if (v.key && v.type) {
          switch (v.type) {
            case 'area':
              if (!values.country_code) break;
              result[v.key] = [values.country_code, values.province_code, values.city_code];
              delete result.country_code;
              delete result.province_code;
              delete result.city_code;
              break;
            case 'time':
              if (!values[v.key]) break;
              result[v.key] = moment(values[v.key] * 1000);
              break;
            case 'string':
              v.key.forEach((field) => {
                result[field] = isEmpty(values[field]) ? values[field] : `${values[field]}`;
              });
              break;
            case 'number':
              v.key.forEach((field) => {
                result[field] = isEmpty(values[field]) ? values[field] : Number(values[field]);
              });
              break;
            case 'timeRange': {
              const fromKey = v.from[0];
              const toKey = v.from[1];
              const from = values[fromKey];
              const to = values[toKey];
              if (!from && !to) break;
              result[v.key] = [from ? moment(from * 1000) : null, to ? moment(to * 1000) : null];
              delete result[fromKey];
              delete result[toKey];
              break;
            }
            case 'commaArr':
              if (!values[v.key]) {
                result[v.key] = [];
                break;
              }
              result[v.key] = values[v.key]?.toString().split(',');
              break;
            case 'commaNumArr':
              if (!values[v.key]) {
                result[v.key] = [];
                break;
              }
              result[v.key] = values[v.key]
                ?.toString()
                .split(',')
                .map((n) => Number(n));
              break;
            case 'json':
              if (!values[v.key]) {
                result[v.key] = values[v.key];
                break;
              }
              result[v.key] = JSON.parse(values[v.key]);
              break;
            default:
              break;
          }
        }
      });
    } catch (e) {
      console.error(e);
    }
  }
  return result;
};

/**
 * 秒转小时
 */
export const toHours = (seconds) => {
  if (seconds && Number(seconds) > 0) {
    if (seconds < 3600) return `${(seconds / 60).toFixed(1)}分钟`;
    return `${(seconds / 3600).toFixed(1)}小时`;
  }
  return '0小时';
};

/**
 * @description:
 * 用于配合useFormTable的格式化函数
 * @param {object} params 需要格式化的对象
 * @param {object} formatObj 需要单独格式化处理的key，value可以为一个objet 或者 一个 function，返回值需要为object
 * @param {array[string]} notformat 不需要格式化的key的数组集合
 * @return {object}
 */
export const format = (params, formatObj = {}, notformat = []) => {
  let res = { ...params };
  Object.keys(params)
    .filter((k) => !notformat.includes(k))
    .forEach((k) => {
      if (formatObj[k]) {
        const obj = typeof formatObj[k] === 'function' ? formatObj[k](res[k]) : formatObj[k];
        delete res[k];
        res = Object.assign(res, obj);
        return;
      }
      // TODO 内置的时间戳类型转换，此块之后可以单独提取出来
      if (k.includes('time') && Array.isArray(res[k])) {
        const [begin, end] = res[k];
        delete res[k];
        const obj = {};
        obj[`${k}_begin`] = begin?.startOf('day').unix();
        obj[`${k}_end`] = end?.endOf('day').unix();
        res = Object.assign(res, obj);
        return;
      }
      // 内置的时间戳类型转换，和上面不同的是，这个是用来处理java参数的，小驼峰格式
      if (k.includes('Time') && Array.isArray(res[k])) {
        const [begin, end] = res[k];
        delete res[k];
        const obj = {};
        obj[`${k}Begin`] = begin?.startOf('day').unix();
        obj[`${k}End`] = end?.endOf('day').unix();
        res = Object.assign(res, obj);
        return;
      }
      // 如果给后端的数据是obj or arr 自动string下
      if (typeof res[k] === 'object' && res[k] !== null) {
        const stringify = JSON.stringify(res[k]);
        delete res[k];
        res = Object.assign(res, { [k]: stringify });
      }
    });
  return res;
};

/**
 * 用于java接口格式化时间参数
 * @param {object} params 需要格式化的对象
 * @param {string} timeKey 时间参数的key
 * @returns {object}
 */
export const formatTimeParamsJAVA = (params, timeKey) => {
  let res = { ...params };
  if (res[timeKey]) {
    const obj = {};
    obj[`${timeKey}Begin`] = res[timeKey][0].startOf('day').unix();
    obj[`${timeKey}End`] = res[timeKey][1].endOf('day').unix();
    res = Object.assign(res, obj);
    delete res[timeKey];
  }
  return res;
};

/**
 * 过滤掉Object中的值为falsy的key
 * false、空字符串、null、undefined、等等均会被过滤
 * @param params Object
 */
export const falsyParamsFilter = (params) => {
  if (params) {
    const newParams = {};
    // false、空字符串、null、undefined、等等均会被过滤
    Object.keys(params)
      .filter((key) => !!params[key] || params[key] === 0)
      .forEach((key) => {
        newParams[key] = params[key];
      });
    return newParams;
  }
  return params;
};

/**
 * 将数组转换为对象
 * @param {array} list 数组列表
 * @param {string} keyField 作为key的字段名，默认 'id'
 * @param {string} valueField 作为value的字段名，默认 'name'
 * @return {object} 返回 { [key]: value } 格式的对象
 * @example
 * const list = [{ id: 1, name: 'A' }, { id: 2, name: 'B' }];
 * arrayToMap(list); // { 1: 'A', 2: 'B' }
 * arrayToMap(list, 'id', 'code'); // { 1: 'A', 2: 'B' } (如果 valueField 为 code)
 */
export const arrayToMap = (list, keyField = 'id', valueField = 'name') => {
  if (!Array.isArray(list) || list.length === 0) return {};
  return list.reduce((acc, item) => {
    if (item && item[keyField] !== undefined) {
      acc[item[keyField]] = item[valueField];
    }
    return acc;
  }, {});
};
